import * as React from "react";
const sizes = {
    xs: 16,
    sm: 20,
    md: 20,
    lg: 24,
    xl: 36,
};
function SvgBell(props) {
    return (React.createElement("svg", Object.assign({ width: sizes[props.size || "lg"], height: sizes[props.size || "lg"], viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M12 2C8.13397 2 4.99997 5.13513 4.99997 9.00251L5 11.4977C5 12.4906 4.51657 13.9371 3.52529 15.792C3.00859 16.7589 3.72806 17.9998 4.84787 18H19.1568C20.2502 18 21.0051 16.7854 20.4826 15.7976C19.4863 13.9142 19 12.4639 19 11.4977L19 9.00251C19 5.13513 15.866 2 12 2Z", fill: "currentColor" }),
        React.createElement("path", { d: "M14.9798 19.3487C14.8066 20.8413 13.5386 22 12 22C10.4614 22 9.19333 20.8413 9.02014 19.3487H14.9798Z", fill: "currentColor" })));
}
export default SvgBell;
